module.exports = __webpack_public_path__ + "static/media/AY.597c6d7d.png";